import {useGTMDispatch} from './react-gtm-hook/index'
import {transformAlgoliaItemsForGA4} from './utils'

export const useItemDataTracking = () => {
  const sendDataToGTM = useGTMDispatch();
  const sendItemData = (item, badges) => {   
    setTimeout(() => {
      try {
        const _items = transformAlgoliaItemsForGA4([item],null, {badges})
        const eventData = {
          event: 'view_item',
          ecommerce: {
            currency: 'GBP',
            value: _items[0].price * _items[0].quantity,
            items: _items
        },
      }
        sendDataToGTM(eventData)  
      } catch (error) {
        console.error('useItemDataTracking error within setTimeout: ' + error.message)
      }
    }, 0);
  };
  return sendItemData;
};